module.exports = __webpack_public_path__ + "static/media/frontdesk_s.827577ba.jpg";